var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.wordCanShow),expression:"wordCanShow"}],staticClass:"word-elem po container",class:_vm.getWordClass,style:(_vm.getWordStyle),domProps:{"innerHTML":_vm._s(_vm.currentHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }